import {
  Anchor,
  Box,
  Button,
  Checkbox,
  Divider,
  Group,
  Select,
  Textarea,
} from "@mantine/core";
import { IconMail, IconUser } from "@tabler/icons-react";

import { Input } from "@mantine/core";
import SFC_logo from "/Logo/SFC_logo.jpg";
import { authClient } from "@/lib/auth-clients";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function SignUpPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentStage, setCurrentStage] = useState(0);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (password, confirmPassword, email) => {
    if (!password || !confirmPassword || !email) {
      notification.error({
        message: t("signup.allFieldsRequired") || "所有欄位都必須填寫",
        description:
          t("signup.allFieldsRequiredDescription") ||
          "請確保所有欄位都已填寫完整",
      });
      return;
    }

    if (password.length < 8) {
      notification.error({
        message: t("signup.passwordTooShort"),
        description: t("signup.passwordTooShortDescription"),
      });
      return;
    }

    if (password !== confirmPassword) {
      notification.error({
        message: t("signup.passwordMismatch") || "密碼不一致",
        description:
          t("signup.passwordMismatchDescription") ||
          "密碼與確認密碼不相符，請重新輸入",
      });
      return;
    }

    try {
      const result = await authClient.signUp.email({
        email,
        password,
        name: email,
      });

      if (result.error) {
        notification.error({
          message: t("signup.registerFailed") || "註冊失敗",
          description:
            result.error.message ||
            t("signup.serverError") ||
            "伺服器錯誤，請稍後重試",
        });
        return;
      }

      if (result.data) {
        notification.success({
          message: t("signup.registerSuccess") || "註冊成功",
          description:
            t("signup.registerSuccessDescription") || "帳號已成功建立",
        });
        navigate("/login");
      }
    } catch (error) {
      console.error("Error during signup:", error);
      notification.error({
        message: t("signup.registerFailed") || "註冊失敗",
        description:
          error?.message ||
          t("signup.serverError") ||
          "伺服器錯誤，請稍後重試",
      });
    }
  };
  const handleOnChange = (value, changeState) => {
    changeState(value);
  };

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="w-[487px] rounded-xl bg-white px-16">
        {currentStage === 0 ? (
          <>
            <img src={SFC_logo} />
            <div className="text-6xl font-bold" style={{ color: "#6F6F6F" }}>
              {t("signup.title")}
            </div>
            {/* <div className="py-4">
              <Button
                variant="filled"
                color="gray"
                style={{ width: "100%" }}
                radius="md"
              >
                {t("signup.googleLogin")}
              </Button>
            </div>
            <Divider my="xs" label={t("signup.or")} labelPosition="center" /> */}
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("signup.email")}</div>
              <Input
                value={email}
                onChange={(e) => handleOnChange(e.target.value, setEmail)}
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
              />
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("signup.setPassword")}</div>
              <Input
                value={password}
                onChange={(e) => handleOnChange(e.target.value, setPassword)}
                placeholder={t("signup.passwordPlaceholder")}
                leftSection={<IconUser size={16} />}
              />
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>
                {t("signup.confirmPassword")}
              </div>
              <Input
                value={confirmPassword}
                onChange={(e) =>
                  handleOnChange(e.target.value, setConfirmPassword)
                }
                placeholder={t("signup.passwordPlaceholder")}
                leftSection={<IconUser size={16} />}
              />
            </div>
            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem 0" }}
              radius="md"
              onClick={() => handleSubmit(password, confirmPassword, email)}
            >
              {t("signup.register")}
            </Button>
            <div className="flex items-center justify-center p-[1rem]">
              <Anchor
                onClick={() => navigate("/login")}
                style={{ color: "#6F6F6F", cursor: "pointer" }}
              >
                {t("signup.haveAccount")}
              </Anchor>
            </div>
          </>
        ) : (
          <>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("signup.name")}</div>
              <Input
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
              />
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("signup.phoneNumber")}</div>
              <Input
                placeholder={t("signup.passwordPlaceholder")}
                leftSection={<IconUser size={16} />}
              />
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("signup.country")}</div>
              <Select
                placeholder="Pick value"
                data={["React", "Angular", "Vue", "Svelte"]}
              />
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("signup.bio")}</div>
              <Textarea placeholder="Input placeholder" />
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>
                {t("signup.howDidYouHear")}
              </div>
              <div className="flex items-center justify-center p-[1rem]">
                <Group mt="xs" style={{ color: "#6F6F6F" }}>
                  <Checkbox
                    value="react"
                    label={t("signup.companyRequirement")}
                  />
                  <Checkbox value="ng" label={t("signup.internet")} />
                  <Checkbox value="vue" label={t("signup.exhibition")} />
                  <Checkbox value="vue" label={t("signup.emailNotification")} />
                  <Checkbox value="vue" label={t("signup.agent")} />
                </Group>
              </div>
            </div>

            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem 0" }}
              radius="md"
              onClick={() => setCurrentStage(1)}
            >
              {t("signup.confirm")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

export default SignUpPage;
